import omit from 'lodash.omit';
import pick from 'lodash.pick';
import React from 'react';
import { DetailsInfo, ICard } from '../../../types/Card';
import { DH } from '../../../utils/DataHook';
import { isExpired } from '../../../utils/expirationUtils';
import { ActionButtons } from '../elements/ActionButtons';
import { CardDetails } from '../elements/CardDetails';
import { CardDetailsWrapper } from '../elements/CardDetailsWrapper';
import { Overlay } from '../elements/Overlay';
import { ICardsListProps } from '../types';
import { AriaNode } from '../elements/AriaNode';
import { Container, Row, RowHeader, TableHeader } from './elements';
import { RemovalLoading } from './elements/RemovalLoading';

const detailsPropKeys: DetailsInfo[] = ['billingAddress', 'additionalInformation', 'creditCardId'];

export const CardsListDesktop: React.FC<ICardsListProps> = (props) => {
  const { cards, expandCard, collapseCard, expandedCardId, isRemovingInProcess, rtl } = props;
  const headerProps = (card: ICard): Omit<ICard, DetailsInfo> => omit(card, detailsPropKeys);
  const cardDetailsProps = (card: ICard): Pick<ICard, DetailsInfo> => pick(card, detailsPropKeys);

  return (
    <div data-hook={DH.CardsListInnerWrapper.Desktop}>
      <TableHeader />
      <Container>
        {cards.map((card, idx) => {
          const isExpanded: boolean = expandedCardId === card.creditCardId;

          return (
            <Row isExpanded={isExpanded} key={card.creditCardId} dataHook={DH.CardRow.WrapperBase}>
              {isExpanded && isRemovingInProcess && (
                <Overlay center loading>
                  <RemovalLoading />
                </Overlay>
              )}
              <AriaNode
                data-hook={DH.CardRow.ContainerBase(card.creditCardId)}
                role="button"
                aria-expanded={isExpanded}
                onClick={() => (isExpanded ? collapseCard() : expandCard(card.creditCardId))}
              >
                <RowHeader
                  {...headerProps(card)}
                  creditCardId={card.creditCardId}
                  isExpanded={isExpanded}
                  isExpired={isExpired(card.expiration)}
                  rtl={rtl}
                />
              </AriaNode>
              {isExpanded && (
                <CardDetailsWrapper>
                  <CardDetails {...cardDetailsProps(card)} />
                  <ActionButtons />
                </CardDetailsWrapper>
              )}
            </Row>
          );
        })}
      </Container>
    </div>
  );
};
